<form class="my-8 flex flex-col gap-8" [formGroup]="formGroup" (ngSubmit)="onContactFormSubmit()">
    <div class="flex w-full flex-col gap-8 lg:flex-row">
        <div class="flex w-full flex-col gap-1 lg:w-1/2">
            <label class="text-label-large text-neutral-20" for="firstname">
                {{ "contact_form_block.firstname" | transloco }}
            </label>
            <input
                class="placeholder:text-neutral-variant-60 border-neutral-variant-40/20 w-full rounded-md border px-4 py-3"
                formControlName="firstname"
                placeholder="John*"
                type="text"
                [class.border-red-500]="formGroup | formControlHasError: 'firstname'"
            />
        </div>

        <div class="flex w-full flex-col gap-1 lg:w-1/2">
            <label class="text-label-large text-neutral-20" for="lastname">
                {{ "contact_form_block.lastname" | transloco }}
            </label>
            <input
                class="placeholder:text-neutral-variant-60 border-neutral-variant-40/20 w-full rounded-md border px-4 py-3"
                formControlName="lastname"
                placeholder="Doe*"
                type="text"
                [class.border-red-500]="formGroup | formControlHasError: 'lastname'"
            />
        </div>
    </div>

    <div class="flex w-full flex-col gap-8 lg:flex-row">
        <div class="flex w-full flex-col gap-1 lg:w-1/2">
            <label class="text-label-large text-neutral-20" for="business_name">
                {{ "contact_form_block.business_name" | transloco }}
            </label>
            <input
                class="placeholder:text-neutral-variant-60 border-neutral-variant-40/20 w-full rounded-md border px-4 py-3"
                formControlName="businessName"
                placeholder="{{ 'contact_form_block.business_name_placeholder' | transloco }}*"
                type="text"
                [class.border-red-500]="formGroup | formControlHasError: 'businessName'"
            />
        </div>

        <div class="flex w-full flex-col gap-1 lg:w-1/2">
            <label class="text-label-large text-neutral-20" for="email">
                {{ "contact_form_block.email" | transloco }}
            </label>
            <input
                class="placeholder:text-neutral-variant-60 border-neutral-variant-40/20 w-full rounded-md border px-4 py-3"
                formControlName="email"
                placeholder="john.doe@example.com*"
                type="text"
                [class.border-red-500]="formGroup | formControlHasError: 'email'"
            />
        </div>
    </div>

    <div class="flex w-full gap-8">
        <div class="flex w-full flex-col gap-1">
            <label class="text-label-large text-neutral-20" for="object">
                {{ "contact_form_block.object" | transloco }}
            </label>
            <input
                class="placeholder:text-neutral-variant-60 border-neutral-variant-40/20 w-full rounded-md border px-4 py-3"
                formControlName="object"
                placeholder="{{ 'contact_form_block.object_placeholder' | transloco }}*"
                type="text"
                [class.border-red-500]="formGroup | formControlHasError: 'object'"
            />
        </div>
    </div>

    <div class="flex w-full gap-8">
        <div class="flex w-full flex-col gap-1">
            <label class="text-label-large text-neutral-20" for="message">
                {{ "contact_form_block.message" | transloco }}
            </label>
            <textarea
                class="placeholder:text-neutral-variant-60 border-neutral-variant-40/20 min-h-30 w-full rounded-md border px-4 py-3"
                formControlName="message"
                placeholder="{{ 'contact_form_block.message_placeholder' | transloco }}*"
                type="text"
                [class.border-red-500]="formGroup | formControlHasError: 'message'"
            ></textarea>
        </div>
    </div>

    <div class="mx-auto flex w-full flex-col justify-start gap-8 lg:max-w-150 lg:min-w-150">
        <div class="flex grow items-center gap-4">
            <div class="flex max-w-11 min-w-11 items-center justify-center">
                <input
                    class="placeholder:text-neutral-variant-60 border-neutral-variant-40/20 size-4.5 cursor-pointer rounded-md border py-3"
                    formControlName="subscribeToNewsletter"
                    type="checkbox"
                />
            </div>
            <label class="text-body-small text-neutral-20" for="subscribeToNewsletter">
                {{ "contact_form_block.subscribe_to_newsletter" | transloco }}
            </label>
        </div>

        <div class="flex grow gap-4">
            <div
                class="group bg-primary-80 has-checked:bg-primary relative inline-flex max-h-6 w-11 shrink-0 cursor-pointer rounded-full p-0.5 transition-colors duration-200 ease-in-out has-focus-visible:outline-2"
            >
                <span
                    class="size-5 cursor-pointer rounded-full bg-white transition-transform duration-200 ease-in-out group-has-checked:translate-x-5"
                ></span>
                <input
                    role="button"
                    type="checkbox"
                    formControlName="acceptPrivacyPolicy"
                    [checked]="(formGroup | formGroupGet: 'acceptPrivacyPolicy')?.value"
                    class="absolute inset-0 cursor-pointer appearance-none focus:outline-hidden"
                />
            </div>
            <div class="flex flex-col items-start justify-start gap-x-2 md:flex-row md:items-center">
                <label class="text-body-small text-neutral-20" for="acceptPrivacyPolicy">
                    {{ "contact_form_block.accept_privacy_policy" | transloco }}
                </label>
                <a
                    [href]="privacyPolicyPageRef() | pathFromItem: 'page'"
                    target="_blank"
                    class="text-primary text-body-small mt-auto flex items-center gap-x-2"
                >
                    <span>{{ privacyPolicy()?.translations_refs | getTranslation: "title" }}</span>
                </a>
            </div>
        </div>

        <button
            class="bg-primary hover:bg-primary/80 mx-auto w-full cursor-pointer rounded-md px-6 py-3 text-white disabled:cursor-not-allowed disabled:opacity-50 lg:w-auto lg:max-w-150 lg:min-w-150"
            type="submit"
            [disabled]="
                isSubmitting() ||
                (formGroup | formControlHasError) ||
                !(formGroup | formGroupGet: 'acceptPrivacyPolicy')?.value
            "
        >
            {{ "contact_form_block.submit" | transloco }}
        </button>
    </div>
</form>
